import React, { useEffect, useState } from "react";

import axios from "axios";
import { BASE_URL } from "./axios";
import { ToastContainer } from "react-toastify";
import { handleErrorToast } from "../../utils/ReusableFunctions";
import { SearchBig } from '../../utils/ReusableSVGs';

import Dashboardnavbar from "../../layout/Navbar/Navbar"

import {
    AddSiteSubcompanys, UpdateSiteSubcompanyupdate, DeleteSiteSubcompany
} from "./SubCompanyCrud"

import "./Subcompany.css";
const SiteSubcompanyTable = () => {

    const [buffer, setBuffering] = useState(true); //buffering logic

    const [subCompanyList, setSubCompanyList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };



    const getSiteSubcompanies = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {



            const res = await axios.get(
                // `${BASE_URL}/configuration/subcompanyfilterbysubcompanycount/${toggleCompany}/active/`
                `${BASE_URL}/configuration/subcompany/`
                // `${BASE_URL}/configuration/subcompany`
            );
            setSubCompanyList(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSiteSubcompanies();
    }, []);




    return (
        <>

            {/* <Dashboardnavbar name={"Sub Company"} url="Sub Company" /> */}
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='content-tabs'>
                <div class="attendance-subcont">
                    <div className="field-cont flex-row justify-between" style={{ width: "100%" }}>

                        <div className="field-cont-div">
                            <SearchBig />
                            <input
                                placeholder="Search Sub Company"
                                className="attendance-input-field "
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            <hr className="field-cont-hr" />

                        </div>


                        <AddSiteSubcompanys getSiteSubcompanies={getSiteSubcompanies} />

                    </div>
                </div>

                <div className="table-css-white-background">
                    <div className="table-box  scroll-container-table" >
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">Sr no.</th>
                                    <th className="table-heading-text">Title</th>
                                    <th className="table-heading-text">Company Name</th>
                                    <th className="table-heading-text">Company Address</th>
                                    <th className="table-heading-text">Company Number</th>
                                    <th className="table-heading-text">Company Gst</th>
                                    <th className="table-heading-text">Company Logo</th>

                                    <th
                                        className="table-heading-text text-center"
                                    // style={{ padding: "30px 45px" }}
                                    >
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {subCompanyList
                                        ?.filter((e) =>
                                            e.title.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) =>
                                            a.title.localeCompare(b.title, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>


                                                <tr className="custom-table-head-td">


                                                    <td className="table-body">{index + 1}</td>
                                                    <td className="table-body">{i.title} </td>
                                                    <td className="table-body">{i.company_name}</td>
                                                    <td className="table-body">{i.company_address}</td>
                                                    <td className="table-body">{i.company_number}</td>
                                                    <td className="table-body">{i.company_gst}</td>
                                                    <td className="table-body text-center">
                                                        {i.company_logo && (
                                                            <a href={i.company_logo} target="_blank">
                                                                {" "}
                                                                {/* <PDFIcon /> */}
                                                                View
                                                            </a>
                                                        )}
                                                    </td>

                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                        <UpdateSiteSubcompanyupdate
                                                            i={i} designationId={i.id}
                                                            getSiteSubcompanies={getSiteSubcompanies}


                                                        />


                                                        <DeleteSiteSubcompany
                                                            i={i}
                                                            getSiteSubcompanies={getSiteSubcompanies}
                                                        />

                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

export default SiteSubcompanyTable